<p-dialog
    [visible]="prompt !== null"
    [modal]="true"
    [closable]="!busy"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="false"
    [focusOnShow]="false"
    styleClass="map-password-dialog"
    (onShow)="focusInput()"
    (onHide)="cancel()">

    <div class="mpw-body" *ngIf="prompt as p">
        <div class="mpw-icon">
            <i class="pi pi-lock"></i>
        </div>

        <h3 class="mpw-title">{{ 'log.channels.password.title' | transloco }}</h3>
        <p class="mpw-text">
            {{ (isPowerFt ? 'log.channels.password.hintPowerft' : 'log.channels.password.hintVision') | transloco }}
        </p>

        <form class="mpw-form" autocomplete="off" (ngSubmit)="submit()">
            <input
                #passwordInput
                type="password"
                name="mapPassword"
                class="mpw-input"
                [class.mpw-input--invalid]="p.invalid && !p.busy"
                autocomplete="off"
                autocapitalize="off"
                spellcheck="false"
                [attr.aria-invalid]="p.invalid"
                [disabled]="p.busy"
                [placeholder]="'log.channels.password.placeholder' | transloco"
                [(ngModel)]="password" />

            <small class="mpw-error" *ngIf="p.invalid && !p.busy">
                <i class="pi pi-exclamation-circle"></i>
                {{ 'log.channels.password.invalid' | transloco }}
            </small>

            <div class="mpw-actions">
                <button type="button" class="mpw-btn-ghost" [disabled]="p.busy" (click)="cancel()">
                    {{ 'log.channels.password.cancel' | transloco }}
                </button>
                <button type="submit" class="mpw-btn-primary" [disabled]="!canSubmit">
                    <i class="pi" [class.pi-spin]="p.busy" [class.pi-spinner]="p.busy" [class.pi-unlock]="!p.busy"></i>
                    {{ (p.busy ? 'log.channels.password.verifying' : 'log.channels.password.unlock') | transloco }}
                </button>
            </div>
        </form>
    </div>
</p-dialog>
